import * as React from 'react';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

type Severity = 'success' | 'error';

const useSnackbar = () => {
  const [open, setOpen] = React.useState<boolean>(false);
  const [message, setMessage] = React.useState<string>('');
  const [severity, setSeverity] = React.useState<Severity>('success');

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const successAlert = (msg: string) => {
    setMessage(msg);
    setSeverity('success');
    setOpen(true);
  };

  const errorAlert = (msg: string) => {
    setMessage(msg);
    setSeverity('error');
    setOpen(true);
  };

  const SnackbarComponent = () => (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'top',horizontal:"center"}}>
      <Alert onClose={handleClose} severity={severity} variant="filled" sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );

  return { successAlert, errorAlert, SnackbarComponent };
};

export default useSnackbar;